import { Component } from 'react';
import { connect } from 'react-redux';
import { downloadPostcodePlan } from '../../../../actions/postcode-plan';
import IgniteDataTable from '../../../../components/common/datatable';
import { history } from '../../../../store';

class PostcodePlansList extends Component {
  handleDownload(id) {
    const { dispatch } = this.props;

    dispatch(downloadPostcodePlan(id));
  }

  render() {
    const columns = [
      {
        prop: 'name',
        title: 'Name',
        format: data => <div style={ { whiteSpace: 'break-spaces' } }>{data}</div>
      },
      {
        prop: 'postcodes',
        title: 'Postcode(s)',
        format: data =>
          <div style={ { whiteSpace: 'break-spaces' } }>{data.map(postcode => postcode.label).toString().replaceAll(',', ', ')}</div>
      },
      {
        prop: 'start-date',
        title: 'Start Date',
      },
      {
        prop: 'end-date',
        title: 'End Date',
      },
      {
        prop: 'objective-type',
        title: 'Objective Type',
      },
      {
        prop: 'total-points-paid',
        title: 'Total Points Paid',
      }
    ];

    const actions = [
      {
        label: 'Details',
        callback: (row) => {
          history.push(`/admin/objectives/postcode-plans/${row.id}`);
        }
      },
      {
        label: 'Download',
        color: 'grey',
        callback: (row) => {
          this.handleDownload(row.id);
        }
      },
      {
        label: 'Clone',
        color: 'grey',
        callback: (row) => {
          history.push(`/admin/objectives/postcode-plans/${row.id}/clone`);
        }
      }
    ];

    return (
      <IgniteDataTable
        data={this.props.postcodePlans}
        hasAttributes
        columns={columns}
        actions={actions}
        actionWidth="400"
        hideId={false}
        remote
      />
    );
  }
}

export default connect()(PostcodePlansList);
